/**
 * 用户相关操作类
 */

import $ from 'jquery'
import cookie from 'js-cookie'
import config from './config'
import mc from '@/components/common/mc-lib'

// store 相关
// import * as types from '@/store/mutation-types'

/**
 * 设置用户登录token
 * @param {String} token token字符串
 */
export const setMemberToken = token => {
  cookie.set(config.ProjectName + '_UserLoginToken', token, {
    expires: 7,
    path: '/'
    //, domain: config.domainName
  })
}

/**
 * 获取登录用户token
 */
export const getMemberToken = () => {
  return cookie.get(config.ProjectName + '_UserLoginToken', {
    expires: 7,
    path: '/'
    //, domain: config.domainName
  })
}

/**
 * 删除登录用户token
 */
export const deleteMemberToken = () => {
  cookie.remove(config.ProjectName + '_UserLoginToken', {
    expires: 7,
    path: '/'
    //, domain: config.domainName
  })
}

/**
 * 退出登录
 */
export const loginOut = () => {
  deleteMemberToken()
  window.location.href = '/'
}

/**
 * 获得登录用户模型
 */
export const getLoginMemberModel = (hasLoading = true) => {
  let def = $.Deferred()
  mc.Ajax({
    url: '/Login/GetLoginWebModel',
    data: {
      token: getMemberToken()
    },
    hasLoading: hasLoading,
    success(res) {
      def.resolve(res)
    },
    fail(res) {
      def.reject(res)
    },
    error(res) {
      def.reject(res)
    }
  })
  return def
}

export default {
  setMemberToken: setMemberToken,
  getMemberToken: getMemberToken,
  deleteMemberToken: deleteMemberToken,
  loginOut: loginOut,
  getLoginMemberModel: getLoginMemberModel
}



// WEBPACK FOOTER //
// ./src/components/common/user.js